import { render } from "./editar.vue?vue&type=template&id=a960a9c4&scoped=true"
import script from "./editar.vue?vue&type=script&lang=js"
export * from "./editar.vue?vue&type=script&lang=js"

import "./editar.vue?vue&type=style&index=0&id=a960a9c4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a960a9c4"]])

export default __exports__